import React, {useState, useEffect} from "react";
import { Button, Table, Tooltip, Modal } from "antd";
import { 
  EditOutlined, 
  DeleteOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';
import { useHistory } from "react-router-dom";
import tds_mail from "../services/tds_mail.service";

const { confirm } = Modal;

export default function TdsMailList() {
  const [loading, set_loading] = useState(false);
  const [data, set_data] = useState([]);
  const history = useHistory();

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id'
    },
    {
      title: 'Prénom',
      dataIndex: 'email',
      key: 'email',
      render: (value, record) => {
        return <>
          <p key={record.id + "_name"}>{record.firstname} {record.lastname}</p>
        </>
      }
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      render: (value, record) => {
        return <>
          <p key={record.id + "_email"}>{record.email}</p>
        </>
      }
    },
    {
      title: 'Actif',
      dataIndex: 'active',
      key: 'active',
      render: (value, record) => {
        if (value) {
          return <CheckCircleOutlined className="record_active" />
        } else {
          return <CloseCircleOutlined className="record_disabled" />          
        }
      }
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      className: 'col_action',
      render: (value, record) => {
        return <>
          <Tooltip title="Modifier">
            <Button onClick={(e) => edit(e, record.id)} shape="circle" icon={<EditOutlined />} />
          </Tooltip>
          <Tooltip title="Supprimer">
            <Button onClick={(e) => del(e, record.id)} shape="circle" icon={<DeleteOutlined />} />
          </Tooltip>
        </>
      }
    },
  ]

  // list -----------------------------------------------------------
  const list = async () => {
    tds_mail
      .list()
      .then(r =>  {
        if (r.data) {
          set_data(r.data);
        }
      })
      .catch(error => {
        console.log(error);
      })
  }

  // create ---------------------------------------------------------
  const create = (e, id) => {
    history.push('/tds_mail/');
  }

  // edit -----------------------------------------------------------
  const edit = (e, id) => {
    history.push('/tds_mail/' + id);
  }

  // list -----------------------------------------------------------
  const del = async (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    confirm({
      title: 'Confirmer la suppression ?',
      content: 'La suppression est définitive',
      onOk() {
        return new Promise(async (resolve, reject) => {
          await tds_mail.del(id);
          await list();
          resolve();
        });
      },
      onCancel() {},
    });
  }

  // useEffect ------------------------------------------------------
  useEffect(() => {
    set_loading(true);
    list().then(r => set_loading(false));
  }, [])

  // render ---------------------------------------------------------
  return (
    <div className="private_page_wrapper">

      <div className="header">
        <span className="title">Destinataires TDS</span>
        <span className="subtitle">Gestion des destinataires qui recevront automatiquement les données TDS par mail</span>
      </div>

      <div className="data_list_toolbar">
        <div className="search_criteria">

        </div>
        <div className="action_toolbar">
          <Button onClick={create}>Créer</Button>
        </div>
      </div>

      <div className="data_list">
        <Table 
          columns={columns} 
          dataSource={data} 
          rowKey="id"
          loading={loading}
          className="common_list"
        />
      </div>

    </div>
  )

}